import { FC, useMemo } from 'react'
import { useFormState } from 'react-final-form'
import { SUPPORT_TEL, SUPPORT_TEL_FORMATTED } from 'constants/links'
import IconAlert from 'remixicon/icons/System/alert-fill.svg?react'
import { OrderCreateCargo } from 'schema'

import { prepareCargo } from '../../helpers/order'
import { IOrderCreateFormData } from '../../types/orderGuestCreateTypes'
import {
  WEIGHT_SECIAL_SEPARATE_LIMIT_IN_GRAM,
  WEIGHT_SECIAL_SEPARATE_LIMIT_IN_KG,
  WEIGHT_SEPARATE_LIMIT_IN_GRAM,
  WEIGHT_SEPARATE_LIMIT_IN_KG
} from './constants'

export const OrderCargoSeparateWarning: FC = () => {
  const { values } = useFormState<IOrderCreateFormData>()
  const { cargo, cargoType, customer } = values
  const hasSpecialCargoLimits = customer?.hasSpecialCargoLimits

  const isShowWarning = useMemo(() => {
    if (!cargoType) {
      return false
    }

    if (cargo) {
      if (hasSpecialCargoLimits) {
        return prepareCargo(cargo).some(({ weight }) => weight > WEIGHT_SECIAL_SEPARATE_LIMIT_IN_GRAM)
      }

      return prepareCargo(cargo).some(
        ({ type, weight }) => type === OrderCreateCargo.type.PALLET && weight > WEIGHT_SEPARATE_LIMIT_IN_GRAM
      )
    }

    return false
  }, [cargo, cargoType, hasSpecialCargoLimits])

  const message = useMemo(
    () =>
      hasSpecialCargoLimits ? (
        <>
          Для отправки груза, вес которого превышает {WEIGHT_SECIAL_SEPARATE_LIMIT_IN_KG}&nbsp;кг, свяжитесь
          со&nbsp;своим проектным менеджером
        </>
      ) : (
        <>
          Для отправки груза, вес которого превышает {WEIGHT_SEPARATE_LIMIT_IN_KG}&nbsp;кг, свяжитесь с&nbsp;нами
          по&nbsp;телефону{' '}
          <a className="link" href={`tel:${SUPPORT_TEL}`}>
            {SUPPORT_TEL_FORMATTED}
          </a>
        </>
      ),
    [hasSpecialCargoLimits]
  )

  return isShowWarning ? (
    <div className="mt-2 grid grid-cols-[auto_1fr] items-start gap-x-4 rounded bg-negative-container p-3">
      <IconAlert className="text-on-negative-container" containerSize="nm" size="xs" />
      <div className="text-on-surface">{message}</div>
    </div>
  ) : null
}

export default OrderCargoSeparateWarning
